"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monchio-delle-corti": {
    "24411f34": [{
      "hkey": "a0cb32d9",
      "slug": "monchio-delle-corti",
      "name": "Monchio delle Corti",
      "primary": true,
      "skipSearch": false
    }],
    "ticchiano": [{
      "hkey": "a0cb32d9",
      "slug": "monchio-delle-corti",
      "name": "Monchio delle Corti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;